module.exports = __webpack_public_path__ + "static/media/performance-review-empty-state@2x.1ff0015d.png";